var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.$style.suspend},[_c('Suspend',{ref:"suspendRef",on:{"close":_vm.close}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }